import { Dispatcher } from '../dispatcher/Dispatcher';
import { ActionTypes } from '../constants/ActionTypes';

export const CohortServerActionCreators = {
  updateCohort: (cohort) => {
    Dispatcher.dispatch({
      type: ActionTypes.COHORT_UPDATE,
      cohort,
    });
  },

  setSchedule: (cohortPath, schedule) => {
    Dispatcher.dispatch({
      type: ActionTypes.COHORT_SCHEDULE_SET,
      cohortPath,
      schedule,
    });
  },
};
